import AuthFileUploader from "../../../common/AuthFileUploader";
import { useDispatch } from "react-redux";

const FileUploaderEditor = ({ cellInfo, contrNo, siteNo }) => {
  const onUploaded = (e) => {
    // cellInfo.data.filePath = JSON.parse(e.request.response).filePath;

    const filePath = JSON.parse(e.request.response).filePath;

    // cellInfo.setValue(filePath.substring(filePath.lastIndexOf("\\") + 1));
    cellInfo.setValue(filePath);
  };

  return (
    <AuthFileUploader
      uploadMode="instantly"
      uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${contrNo}/${siteNo}/${cellInfo.title}`}
      onUploaded={onUploaded}
    />
  );
};

export default FileUploaderEditor;
